import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { formatPercent } from '@angular/common';

@Pipe({
  name: 'dynamicPercentage',
  pure: false,
  standalone: true
})
export class DynamicPercentagePipe implements PipeTransform {
  locale = inject(LOCALE_ID);

  transform(value: string | number, format?: string): string {
    try {
      const normalizedValue = this.normalizeValue(value);
      return formatPercent(
        normalizedValue,
        this.locale,
        format ?? this.getDynamicDecimalFormat(normalizedValue?.toString())
      );
    } catch (e) {
      console.error(e);
      return value?.toString();
    }
  }

  private normalizeValue(value: string | number) {
    if (typeof value === 'number') return value;

    // Convert number strings with German formatting to ensure the pipe can handle them
    return Number(value?.replaceAll(',', '.'));
  }

  private getDynamicDecimalFormat(value: string) {
    const decimalDigitCount = value?.includes('.') ? value.split('.')[1].length : 0;

    if (decimalDigitCount < 2) return null;
    return `1.${decimalDigitCount - 2}-${decimalDigitCount - 2}`;
  }
}
